module.exports = __webpack_public_path__ + "static/media/sidemenu-dashboard.01464faa.svg";